import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const notifications = [{
  name: 'María',
  city: 'Miami',
  time: 'hace 2 minutos'
}, {
  name: 'Carlos',
  city: 'Madrid',
  time: 'hace 5 minutos'
}, {
  name: 'Ana',
  city: 'México',
  time: 'hace 3 minutos'
}, {
  name: 'Lucía',
  city: 'Bogotá',
  time: 'hace 7 minutos'
}, {
  name: 'Valentina',
  city: 'Buenos Aires',
  time: 'hace 4 minutos'
}, {
  name: 'Sofía',
  city: 'Lima',
  time: 'hace 6 minutos'
}, {
  name: 'Gabriela',
  city: 'Santiago',
  time: 'hace 1 minuto'
}, {
  name: 'Daniela',
  city: 'Guadalajara',
  time: 'hace 8 minutos'
}, {
  name: 'Camila',
  city: 'Medellín',
  time: 'hace 3 minutos'
}, {
  name: 'Isabella',
  city: 'Barcelona',
  time: 'hace 5 minutos'
}];
export function SocialProofNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const showNext = useCallback(() => {
    setCurrentIndex(prev => {
      let next = prev + 1;
      if (next >= notifications.length) next = 0;
      return next;
    });
    setVisible(true);
  }, []);
  useEffect(() => {
    // Initial delay before first notification
    const initialTimer = setTimeout(() => {
      showNext();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [showNext]);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible) return;
    // Show next after 7-10 seconds gap
    if (currentIndex < 0) return;
    const delay = 7000 + Math.random() * 3000;
    const showTimer = setTimeout(() => {
      showNext();
    }, delay);
    return () => clearTimeout(showTimer);
  }, [visible, currentIndex, showNext]);
  const current = currentIndex >= 0 ? notifications[currentIndex] : null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-[320px] md:max-w-[360px]" data-id="element-343">
      <AnimatePresence data-id="element-344">
        {visible && current && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-lg border border-[#F5E6DC] p-3 md:p-4 flex items-center gap-3" data-id="element-345">
            <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-full flex items-center justify-center" data-id="element-346">
              <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-347" />
            </div>
            <div className="min-w-0" data-id="element-348">
              <p className="text-sm font-bold text-[#2D2D2D] leading-tight" data-id="element-349">
                {current.name} de {current.city}
              </p>
              <p className="text-xs text-[#2D2D2D]/60 mt-0.5" data-id="element-350">
                acaba de comprar el programa · {current.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}